import HeaderApi from '../services/HeaderApi';
import Cookie from '../services/Cookie';
import ApplicationSettings from '../services/ApplicationSettings';
import IsServerSideRendering from '../utilities/IsServerSideRendering';

class Profile {
  static async getProfileRequest() {
    if (IsServerSideRendering) {
      return new Promise(resolve => resolve({}));
    }

    const vanityUrlName = Cookie.getCookie('PartnerVanityUrlName') || 'notused';

    return HeaderApi.fetchHeaderWithAuthWithExtendedTimeout(`user?partnerUrlName=${vanityUrlName}`);
  }

  static getProfileFromServer() {
    if (IsServerSideRendering) {
      return new Promise(resolve => resolve({}));
    }

    return this.getProfileRequest()
      .then(profile => {
        this.setCookiePartner(profile.partner);
        this.setLocalStoragePartner(profile.partner);
        return profile;
      });
  }

  static setCookiePartner(partner) {
    const oldAssetUrl = `${ApplicationSettings.getApplicationSetting('cdnUrl')}/partner-assets/${partner.partnerKey}/logo-med.png`;
    const partnerWithAssetUrl = {
      partnerAssetUrl: oldAssetUrl,
      ...partner
    };
    Cookie.setCookie('CVActivePartnerId', partner.partnerId, 4);
    Cookie.setCookie('PartnerAssetUrl', oldAssetUrl, 4);
    Cookie.setCookie('PartnerLongName', partner.partnerLongName, 4);
    Cookie.setCookie('PartnerVanityUrlName', partner.partnerVanityUrlName, 4);
    Cookie.setCookie('PartnerObject', JSON.stringify(partnerWithAssetUrl), 4);
  }

  static setLocalStoragePartner(partner) {
    if (IsServerSideRendering) return;
    localStorage.setItem('PartnerId', partner.partnerId);
    localStorage.setItem('PartnerKey', partner.partnerKey);
    localStorage.setItem('PartnerVanityUrlName', partner.partnerVanityUrlName);
    localStorage.setItem('PartnerWhisperNumber', partner.partnerWhisperNumber);
  }
}

export default Profile;
